<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Danh sách TPV</h1>
      <div class="btn-group float-right">
        <DraggableTable
          :naming="$router.name"
          v-model="fieldsTable"
          @change="filterTable = $event"
        />
      </div>
    </div>
    <div class="card p-10 pt-15 b-t-1-869fb229">
      <div class="card-body">
        <div class="tab-content" id="nav-tabContent">
          <div class="p-10">
            <b-table
              :busy.sync="tbLoading"
              sticky-header
              responsive
              hover
              :items="lists"
              :fields="filterTable"
              :fixed="true"
              :bordered="true"
            >
              <template #table-busy>
                <div class="text-center my-2">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>
              <template #cell(index)="data">
                {{ getIndex(data.index) }}
              </template>
              <template #cell(action)="data">
                <b-dropdown class="text-center" variant="outline-light">
                  <b-dropdown-item class="dropdown-item" @click="detail(data.item)"
                    ><span>&nbsp;</span>Chi tiết
                  </b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>
          </div>
        </div>
        <div class="pagination-bottom">
          <b-pagination
            v-model="search.pageIndex"
            :total-rows="pagination.total"
            :per-page="search.pageSize"
            class="fl-right mr-2"
          ></b-pagination>
        </div>
      </div>
    </div>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import 'vue-simple-suggest/dist/styles.css'
  import Config from '@/thirdParty/config'
  import { NotificationService } from '@/services/notification.service'
  const fieldsTable = [
    { key: 'index', label: 'STT', class: 'text-center' },
    { key: 'merchantName', label: 'Tên', thStyle: 'min-width: 150px' },
    { key: 'merchantEmail', label: 'Email', thStyle: 'min-width: 300px' },
    { key: 'date', label: 'Ngày', thStyle: 'min-width: 150px' },
    { key: 'totalTpv', label: 'Tổng TPV', thStyle: 'min-width: 150px' },
    { key: 'totalTransaction', label: 'Số lượng giao dịch', thStyle: 'min-width: 150px' },
    { key: 'devices', label: 'Thiết bị', thStyle: 'min-width: 150px' },
    { key: 'action', label: 'Thao tác', fixIndex: 999, class: 'text-center' },
  ]
  export default {
    name: 'list-tpv',
    data() {
      return {
        Config,
        fieldsTable,
        filterTable: fieldsTable,
        lists: [],
        showLoading: false,
        tbLoading: false,
        dataUser: JSON.parse(localStorage.getItem('userData')),
        dataTypeCode: [],
        search: {
          pageSize: 20,
          pageIndex: 1,
        },
        pagination: {
          total: 0,
        },
      }
    },
    watch: {
      'search.pageIndex': function () {
        this.fetchData()
      },
    },
    created() {
      this.fetchData()
    },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
    },
    methods: {
      async fetchData() {
        try {
          this.tbLoading = true
          const response = await NotificationService.getListTPV({})
          if (response.code === 1000) {
            console.log(response.data)
            this.lists = response.data.merchantInfos
            this.pagination.total = response.data.count
          } else {
            this.showFailMx(response.message)
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.tbLoading = false
        }
      },
      detail(item) {
        this.$router.push({ path: `/tpv/${item.merchantEmail}/${item.date}` })
      },
    },
  }
</script>
<style scoped>
  .c-poiter {
    cursor: pointer;
  }
  .ACTIVE {
    color: #fff;
    background-color: #28a745;
  }
  .UN_ACTIVE {
    color: #fff;
    background-color: #dc3545;
  }
  .category {
    width: 300px;
  }
</style>
